export default class Book extends React.PureComponent

  constructor: (props) ->
    super(props)

    @state =
      book:           @props.book
      openedUnitsIds: []

    @toggleUnit    = @toggleUnit.bind(this)
    @renderUnit    = @renderUnit.bind(this)
    @renderSegment = @renderSegment.bind(this)

  componentDidMount: ->
    setInterval(@reloadBookIfChanged.bind(this), 5000)

  reloadBookIfChanged: ->
    http.get("#{@props.book.path}/updated_at.json", {}, (data) =>
      if !data.destroyedAt # Refreshing an destroyed book triggers backend 404 errors on BugSnag
        if @state.book.updatedAtTimestamp < data.updatedAtTimestamp
          @reloadBook()
    )

  reloadBook: ->
    http.get("#{@props.book.path}.json", {}, (data) =>
      status        = data.status
      targetFileUrl = data.targetFileUrl

      $('h1 .badge span').html(status)
      $('h1 .badge').removeClass().addClass("badge badge-#{status} rounded-pill")

      if status == 'progress'
        $('h1 .fa-spinner').removeClass('d-none')
      else
        $('h1 .fa-spinner').addClass('d-none')

      if targetFileUrl
        $('.target-download').attr('href', targetFileUrl)
        $('.target-download').removeClass('disabled')

      @setState(book: data)
    )

  isUnitOpen: (unit) ->
    unit.id in @state.openedUnitsIds

  toggleUnit: (unit) ->
    if @isUnitOpen(unit)
      openedUnitsIds = @state.openedUnitsIds.filter((id) => id != unit.id)
    else
      openedUnitsIds = [...@state.openedUnitsIds, unit.id]

    @setState(openedUnitsIds: openedUnitsIds)

  render: ->
    @renderUnits()

  renderUnits: ->
    if @state.book
      @state.book.units.map(@renderUnit)
    else
      ''

  renderUnit: (unit) ->
    <div key={unit.name} className="unit">
      <h4>
        { @renderUnitTitle(unit)   }
        { @renderSummaryIcon(unit) }
        { @renderUnitStatus(unit)  }
        { @renderUnitWarning(unit) }
        { @renderDebugPixel(unit)  }
      </h4>

      <div className="d-flex ps-2">
        { @renderVerticalLine(unit) }

        <table className="table table-striped table-bordered mt-1 mb-0" style={{ tableLayout: 'fixed' }}>
          <tbody>
            { @renderStats(unit)    if !@isUnitOpen(unit) }
            { @renderSegments(unit) if @isUnitOpen(unit)  }
          </tbody>
        </table>
      </div>
    </div>

  renderUnitTitle: (unit) ->
    if unit.identifiers.length <= 1
      "Unit #{unit.name}"
    else
      "Units #{unit.name}"

  renderSummaryIcon: (unit) ->
    if unit.needSummary
      if unit.targetSummary.length
        <a href={"#{@props.book.path}/units/#{unit.id}/summary"} target="_blank">
          <i className="fas fa-diamond mt-1"
             style={{ color: '#ab5dff', marginLeft: '12px' }}
             title="Show summary"/>
        </a>
      else if unit.status == 'translated' # if no summary and unit is translated
        <i className="fas fa-spinner fa-spin mt-1"
           style={{ color: '#ab5dff', marginLeft: '12px' }}
           title="Currently summarizing"/>

  renderUnitStatus: (unit) ->
    classes        = "badge badge-#{unit.status} rounded-pill float-end"
    spinnerClasses = "fas fa-spinner fa-spin ms-2"
    spinnerClasses += " d-none" if unit.status != 'progress'

    if unit.status == 'failed'
      refreshButton = <a href={@props.book.resumeTranslationUrl} data-method="put" class="text-white">
                        <i className="fas fa-refresh"
                           style={{ marginLeft: '10px' }}
                           title="Resume translation"/>
                      </a>

      skipButton = <a href={@props.book.skipUnitAndResumeTranslationUrl} data-method="put" class="text-white">
                     <i className="fas fa-forward-fast"
                        style={{ marginLeft: '10px' }}
                        title="Skip and resume translation"/>
                   </a>

    <small className={classes} title={unit.errorMessage}>
      { unit.status }
      <i className={spinnerClasses} style={{ verticalAlign: 'middle' }}/>
      { refreshButton }
      { skipButton }
    </small>

  renderUnitWarning: (unit) ->
    if @state.book.segmenter != 'raw' && unit.status == 'translated'
      if unit.warning
        <span className="badge rounded-pill float-end text-bg-warning me-2"
              style={{ fontSize: '15px', marginTop: '3px', fontWeight: 500 }}
              title={"Misalignment between source and target number of #{@state.book.segmenter}s"}>
          {unit.targetsCount - unit.sourcesCount}
        </span>
      else
        <i className="fas fa-circle-check float-end  text-success me-2 mt-1"
           style={{ background: 'white', borderRadius: '50%' }}
           title="Correctly aligned"/>
    else if unit.status == 'failed'
      <i className="fas fa-warning text-danger float-end me-2 mt-1"
         title={unit.errorMessage}/>

  renderDebugPixel: (unit) ->
    if @props.admin
      <a href={"#{@props.book.path}/units/#{unit.id}/debug"}
         style={{ position: 'absolute', top: 0, right: 0, width: '2px', height: '2px' }}
         tabIndex="-1"
         target="_blank"/>

  renderVerticalLine: (unit) ->
    buttonClasses = "floating-button fas"
    buttonClasses += " fa-circle-minus" if @isUnitOpen(unit)
    buttonClasses += " fa-circle-plus"  if !@isUnitOpen(unit)

    <div className="vertical-line me-3">
      <i className={buttonClasses}
         onClick={@toggleUnit.bind(this, unit)} />
    </div>

  renderStats: (unit) ->
    sourceSegmenterText = targetSegmenterText = @state.book.segmenter
    sourceSegmenterText += 's' if unit.sourcesCount != 1
    targetSegmenterText += 's' if unit.targetsCount != 1

    sourceWordText = targetWordText = 'word'
    sourceWordText += 's' if unit.sourceWordsCount != 1
    targetWordText += 's' if unit.targetWordsCount != 1

    sourceStats = "#{unit.sourcesCount} #{sourceSegmenterText} - #{unit.sourceWordsCount} #{sourceWordText}"
    targetStats = "#{unit.targetsCount} #{targetSegmenterText} - #{unit.targetWordsCount} #{targetWordText}"
    targetStats = "-" if unit.targetWordsCount == 0 || unit.status == 'untranslated' || unit.status == 'progress'

    <tr key="stats">
      <td className="w-50 text-center" style={{ color: '#888888' }}>
        { sourceStats }
      </td>
      <td className="w-50 text-center" style={{ color: '#888888' }}>
        { targetStats }
      </td>
    </tr>

  renderSegments: (unit) ->
    unit.segments.map(@renderSegment)

  renderSegment: (segment, index) ->
    if segment[0].trim() != '' || segment[1].trim() != ''
      <tr key={index}>
        <td className="w-50">
          <pre style={{ whiteSpace: 'pre-wrap' }}>
            { segment[0] }
          </pre>
        </td>
        <td className="w-50">
          <pre style={{ whiteSpace: 'pre-wrap' }}>
            { segment[1] }
          </pre>
        </td>
      </tr>
